// @flow
import * as eff from 'redux-saga/effects';
import * as chronosActions from 'chronos-actions';

/* eslint-disable */
function uuidv4() {
  // $FlowFixMe
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    // $FlowFixMe
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
/* eslint-enable */

function* autoDeleteFlag(id) {
  yield eff.delay(5 * 1000);
  yield eff.put(chronosActions.deleteFlag(id));
}

export function* notify({
  description = '',
  title = '',
  actions = [],
  appearance = 'normal',
  icon = 'bellIcon',
  resourceType,
  request,
  spinnerTitle = '',
  type,
  autoDelete = true,
}: {
  description?: string,
  title?: string,
  actions?: Array<any>,
  appearance?: string,
  icon?: string,
  resourceType?: string,
  request?: string,
  spinnerTitle?: string,
  type?: string,
  autoDelete?: boolean,
}): Generator<*, void, *> {
  const newFlag = {
    id: uuidv4(),
    title,
    actions,
    appearance,
    description,
    icon,
    resourceType,
    request,
    spinnerTitle,
    type,
  };
  yield eff.put(chronosActions.addFlag(newFlag));
  if (autoDelete) {
    yield eff.fork(autoDeleteFlag, newFlag.id);
  }
}
